// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"42COX":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkContext", ()=>LinkContext);
parcelHelpers.export(exports, "Link", ()=>Link);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _link = require("react-aria-components/Link");
var _skeleton = require("./Skeleton");
var _useDOMRef = require("./useDOMRef");
var _useLayoutEffect = require("react-aria/private/utils/useLayoutEffect");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const LinkContext = /*#__PURE__*/ (0, _react.createContext)(null);
const link = function anonymous(props, overrides) {
    let rules = " ";
    rules += (String(overrides || '').match(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g) || []).join('');
    if (props.isFocusVisible) rules += ' _Lf13';
    else rules += ' _Le13';
    if (props.isStaticColor) rules += ' Oe13';
    else rules += ' Oh13';
    rules += ' OlOVIhfcebS7sd13';
    rules += ' OlOVIhfcebS7sd13';
    rules += ' _Mc13';
    rules += ' _Kd13';
    if (props.staticColor === "white") rules += ' -Ovbhqd-gcwrnr13';
    else if (props.staticColor === "black") rules += ' -Ovbhqd-g4hn3s13';
    rules += ' oR3ltQc13';
    rules += ' nR3ltQc13';
    rules += ' kR3ltQc13';
    rules += ' jR3ltQc13';
    if (props.isStandalone) {
        rules += ' uk13';
        rules += ' ucJ9TBTb13';
        rules += ' ud3Euai13';
        rules += ' uea13';
        rules += ' ugb13';
        rules += ' uhd13';
        rules += ' uje13';
        rules += ' u2NhKxcl13';
        rules += ' uic13';
    }
    if (props.isStandalone) {
        rules += ' -_6BNtrc-c13';
        rules += ' vFHT6Dd13';
    }
    if (props.isStandalone) {
        rules += ' xc13';
        rules += ' _xa13';
    }
    if (props.isStandalone) {
        rules += ' _Fd13';
        rules += ' _FnuYUweb13';
    }
    if (props.isStaticColor) rules += ' pl13';
    else if (props.variant === "secondary") {
        if (props.isPressed) rules += ' po13';
        else if (props.isFocusVisible) rules += ' po13';
        else if (props.isHovered) rules += ' po13';
        else rules += ' pt13';
    } else if (props.variant === "primary") {
        if (props.isPressed) rules += ' ps13';
        else if (props.isFocusVisible) rules += ' ps13';
        else if (props.isHovered) rules += ' ps13';
        else rules += ' pu13';
    }
    rules += ' plOVIhfcA5Qiqd13';
    rules += ' plOVIhfcA5Qiqd13';
    rules += ' Yd13';
    rules += ' Xb13';
    rules += ' _2b13';
    if (props.isStandalone) {
        if (props.isQuiet) {
            if (props.isFocusVisible) {
                rules += ' _Xb13';
                rules += ' __Va13';
            } else if (props.isHovered) {
                rules += ' _Xb13';
                rules += ' __Va13';
            } else rules += ' _Xa13';
        }
    } else {
        rules += ' _Xb13';
        rules += ' __Va13';
    }
    rules += ' __ca13';
    return rules;
};
const Link = /*#__PURE__*/ (0, _react.forwardRef)(function Link(props, ref) {
    [props, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props, ref, LinkContext);
    let { variant = 'primary', staticColor, isQuiet, isStandalone, UNSAFE_style, UNSAFE_className = '', styles, children } = props;
    let domRef = (0, _useDOMRef.useFocusableRef)(ref);
    let isSkeleton = (0, _react.useContext)((0, _skeleton.SkeletonContext)) || false;
    [children, UNSAFE_style] = (0, _skeleton.useSkeletonText)(children, UNSAFE_style);
    (0, _useLayoutEffect.useLayoutEffect)(()=>{
        if (domRef.current) // TODO: should RAC Link pass through inert?
        domRef.current.inert = isSkeleton;
    }, [
        domRef,
        isSkeleton
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _link.Link), {
        ...props,
        ref: domRef,
        style: UNSAFE_style,
        className: (renderProps)=>UNSAFE_className + link({
                ...renderProps,
                variant,
                staticColor,
                isStaticColor: !!staticColor,
                isQuiet,
                isStandalone,
                isSkeleton
            }, styles),
        children: children
    });
});

},{"0":"dGUmc","react/jsx-runtime":"2Is6Z","react":"a1TxN","react-aria-components/Link":"fOCdV","./Skeleton":"1mUnF","./useDOMRef":"9tqah","react-aria/private/utils/useLayoutEffect":"k6VV7","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dGUmc":[function() {},{}],"2mowY":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BadgeContext", ()=>BadgeContext);
parcelHelpers.export(exports, "Badge", ()=>Badge);
var _jsxRuntime = require("react/jsx-runtime");
var _centerBaseline = require("./CenterBaseline");
var _slots = require("react-aria-components/slots");
var _filterDOMProps = require("react-aria/filterDOMProps");
var _icon = require("./Icon");
var _text = require("react-aria-components/Text");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skeleton = require("./Skeleton");
var _content = require("./Content");
var _useDOMRef = require("./useDOMRef");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const BadgeContext = /*#__PURE__*/ (0, _react.createContext)(null);
const badge = function anonymous(props, overrides) {
    let rules = " ";
    let minWidth = false;
    let matches = String(overrides || '').matchAll(/(?:^|\s)(J|G|I|H|_u|_v|_s|__A|_d|_J|z|y|B|A|_P|_9|W|_l|_A|_z|_6|Z|N|L)[^\s]+/g);
    for (let p of matches){
        if (p[1] === "N") minWidth = true;
        rules += p[0];
    }
    if (props.size === "XL") {
        rules += ' uk13';
        rules += ' ucJ9TBTb13';
        rules += ' ud3Euai13';
        rules += ' uea13';
        rules += ' ugb13';
        rules += ' uhd13';
        rules += ' uje13';
        rules += ' u2NhKxcl13';
        rules += ' uic13';
    } else if (props.size === "L") {
        rules += ' uk13';
        rules += ' ucJ9TBTb13';
        rules += ' ud3Euai13';
        rules += ' uea13';
        rules += ' ugb13';
        rules += ' uhd13';
        rules += ' uje13';
        rules += ' u2NhKxcl13';
        rules += ' uic13';
    } else if (props.size === "S") {
        rules += ' uk13';
        rules += ' ucJ9TBTb13';
        rules += ' ud3Euai13';
        rules += ' uea13';
        rules += ' ugb13';
        rules += ' uhd13';
        rules += ' uje13';
        rules += ' u2NhKxcl13';
        rules += ' uic13';
    } else if (props.size === "XS") {
        rules += ' uk13';
        rules += ' ucJ9TBTb13';
        rules += ' ud3Euai13';
        rules += ' uea13';
        rules += ' ugb13';
        rules += ' uhd13';
        rules += ' uje13';
        rules += ' u2NhKxcl13';
        rules += ' uic13';
    } else {
        rules += ' uk13';
        rules += ' ucJ9TBTb13';
        rules += ' ud3Euai13';
        rules += ' uea13';
        rules += ' ugb13';
        rules += ' uhd13';
        rules += ' uje13';
        rules += ' u2NhKxcl13';
        rules += ' uic13';
    }
    if (props.size === "XL") {
        rules += ' -_6BNtrc-e13';
        rules += ' vFHT6Dd13';
    } else if (props.size === "L") {
        rules += ' -_6BNtrc-d13';
        rules += ' vFHT6Dd13';
    } else if (props.size === "S") {
        rules += ' -_6BNtrc-b13';
        rules += ' vFHT6Dd13';
    } else if (props.size === "XS") {
        rules += ' -_6BNtrc-a13';
        rules += ' vFHT6Dd13';
    } else {
        rules += ' -_6BNtrc-c13';
        rules += ' vFHT6Dd13';
    }
    if (props.size === "XL") {
        rules += ' xb13';
        rules += ' _xa13';
    } else if (props.size === "L") {
        rules += ' xb13';
        rules += ' _xa13';
    } else if (props.size === "S") {
        rules += ' xb13';
        rules += ' _xa13';
    } else if (props.size === "XS") {
        rules += ' xb13';
        rules += ' _xa13';
    } else {
        rules += ' xb13';
        rules += ' _xa13';
    }
    if (props.size === "XL") {
        rules += ' _Fd13';
        rules += ' _FnuYUweb13';
    } else if (props.size === "L") {
        rules += ' _Fd13';
        rules += ' _FnuYUweb13';
    } else if (props.size === "S") {
        rules += ' _Fd13';
        rules += ' _FnuYUweb13';
    } else if (props.size === "XS") {
        rules += ' _Fd13';
        rules += ' _FnuYUweb13';
    } else {
        rules += ' _Fd13';
        rules += ' _FnuYUweb13';
    }
    if (props.fillStyle === "outline") rules += ' pm13';
    else if (props.fillStyle === "subtle") rules += ' pm13';
    else if (props.fillStyle === "bold") {
        if (props.variant === "celery") rules += ' pg13';
        else if (props.variant === "chartreuse") rules += ' pg13';
        else if (props.variant === "yellow") rules += ' pg13';
        else if (props.variant === "orange") rules += ' pg13';
        else if (props.variant === "notice") rules += ' pg13';
        else rules += ' px13';
    }
    rules += ' sd13';
    rules += ' ea13';
    rules += ' egLWx3bb13';
    rules += ' _oa13';
    rules += ' Sv13';
    rules += ' SgLWx3bd13';
    rules += ' Rv13';
    rules += ' RgLWx3bd13';
    if (props.size === "XL") {
        if (!minWidth) rules += ' NBaYFfc13';
    } else if (props.size === "L") {
        if (!minWidth) rules += ' N3JjxG13';
    } else if (props.size === "S") {
        if (!minWidth) rules += ' NCe2o8c13';
    } else if (props.size === "XS") {
        if (!minWidth) rules += ' NifsFYc13';
    } else if (!minWidth) rules += ' N4dY0ec13';
    if (props.size === "XL") rules += ' -SFnbic-_JaP8ec13';
    else if (props.size === "L") rules += ' -SFnbic-_J0K2hn13';
    else if (props.size === "S") rules += ' -SFnbic-_JJOW22b13';
    else if (props.size === "XS") rules += ' -SFnbic-_JICefdd13';
    else rules += ' -SFnbic-_Jb13';
    rules += ' -Bu7z1c-oH5kTnc13';
    rules += ' oj13';
    rules += ' nj13';
    rules += ' kj13';
    rules += ' jj13';
    rules += ' qc13';
    rules += ' qsd13';
    rules += ' -Qg41Lb-IAxCW0c13';
    rules += ' -Qg41Lb-gLWx3bIYB8I13';
    rules += ' MAyFGYc13';
    rules += ' Td13';
    rules += ' Qd13';
    rules += ' -aRvJDd-Tu7Fubd13';
    rules += ' _Ca13';
    if (props.fillStyle === "outline") rules += ' g_g13';
    else if (props.fillStyle === "subtle") {
        if (props.variant === "silver") rules += ' g_f13';
        else if (props.variant === "cinnamon") rules += ' gP13';
        else if (props.variant === "brown") rules += ' gO13';
        else if (props.variant === "turquoise") rules += ' gy13';
        else if (props.variant === "pink") rules += ' gT13';
        else if (props.variant === "magenta") rules += ' gS13';
        else if (props.variant === "fuchsia") rules += ' gR13';
        else if (props.variant === "purple") rules += ' gM13';
        else if (props.variant === "indigo") rules += ' gK13';
        else if (props.variant === "blue") rules += ' gG13';
        else if (props.variant === "cyan") rules += ' gC13';
        else if (props.variant === "seafoam") rules += ' gz13';
        else if (props.variant === "green") rules += ' gA13';
        else if (props.variant === "celery") rules += ' gv13';
        else if (props.variant === "chartreuse") rules += ' gJ13';
        else if (props.variant === "yellow") rules += ' gW13';
        else if (props.variant === "orange") rules += ' gV13';
        else if (props.variant === "red") rules += ' gU13';
        else if (props.variant === "gray") rules += ' gI13';
        else if (props.variant === "negative") rules += ' gU13';
        else if (props.variant === "notice") rules += ' gV13';
        else if (props.variant === "positive") rules += ' gA13';
        else if (props.variant === "neutral") rules += ' gI13';
        else if (props.variant === "informative") rules += ' gG13';
        else if (props.variant === "accent") rules += ' gG13';
    } else if (props.fillStyle === "bold") {
        if (props.variant === "silver") rules += ' gm13';
        else if (props.variant === "cinnamon") rules += ' gq13';
        else if (props.variant === "brown") rules += ' gn13';
        else if (props.variant === "turquoise") rules += ' g513';
        else if (props.variant === "pink") rules += ' gx13';
        else if (props.variant === "magenta") rules += ' gD13';
        else if (props.variant === "fuchsia") rules += ' gr13';
        else if (props.variant === "purple") rules += ' go13';
        else if (props.variant === "indigo") rules += ' gl13';
        else if (props.variant === "blue") rules += ' g213';
        else if (props.variant === "cyan") rules += ' gk13';
        else if (props.variant === "seafoam") rules += ' g413';
        else if (props.variant === "green") rules += ' g113';
        else if (props.variant === "celery") rules += ' g713';
        else if (props.variant === "chartreuse") rules += ' gp13';
        else if (props.variant === "yellow") rules += ' gN13';
        else if (props.variant === "orange") rules += ' gQ13';
        else if (props.variant === "red") rules += ' gB13';
        else if (props.variant === "gray") rules += ' g613';
        else if (props.variant === "negative") rules += ' gB13';
        else if (props.variant === "notice") rules += ' gQ13';
        else if (props.variant === "positive") rules += ' g113';
        else if (props.variant === "neutral") rules += ' g613';
        else if (props.variant === "informative") rules += ' g213';
        else if (props.variant === "accent") rules += ' g213';
    }
    rules += ' _jf13';
    rules += ' _kJ8iPYd13';
    rules += ' hXMFGYc13';
    rules += ' mc13';
    rules += ' lc13';
    if (props.fillStyle === "outline") {
        if (props.variant === "negative") rules += ' iFLVMS13';
        else if (props.variant === "notice") rules += ' i9VrKkd13';
        else if (props.variant === "positive") rules += ' ip17Jm13';
        else if (props.variant === "neutral") rules += ' i0ruhAb13';
        else if (props.variant === "informative") rules += ' iG1ze4d13';
        else if (props.variant === "accent") rules += ' iG1ze4d13';
        else rules += ' iA13';
    } else rules += ' iA13';
    rules += ' -_8sjo0b-t5ZbAob13';
    if (props.size === "XL") rules += ' -M_-MBaYFfc13';
    else if (props.size === "L") rules += ' -M_-M3JjxG13';
    else if (props.size === "S") rules += ' -M_-MCe2o8c13';
    else if (props.size === "XS") rules += ' -M_-MifsFYc13';
    else rules += ' -M_-M4dY0ec13';
    rules += ' -_k_-_kc13';
    rules += ' -h_-hc13';
    return rules;
};
const Badge = /*#__PURE__*/ (0, _react.forwardRef)(function Badge(props1, ref) {
    [props1, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)(props1, ref, BadgeContext);
    let { children, variant = 'neutral', size = 'S', fillStyle = 'bold', overflowMode = 'wrap', ...otherProps } = props1; // useProviderProps(props) in v3
    let domRef = (0, _useDOMRef.useDOMRef)(ref);
    let isTextOnly = (0, _reactDefault.default).Children.toArray(props1.children).every((c)=>!/*#__PURE__*/ (0, _reactDefault.default).isValidElement(c));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _slots.Provider), {
        values: [
            [
                (0, _content.TextContext),
                {
                    styles: function anonymous(props) {
                        let rules = " ";
                        rules += ' TAzEcG13';
                        rules += ' QAzEcG13';
                        rules += ' _Jb13';
                        rules += ' _Nc13';
                        rules += ' Pc13';
                        rules += ' _Yb13';
                        if (props.overflowMode === "wrap") rules += ' _7b13';
                        else if (props.overflowMode === "truncate") rules += ' _7c13';
                        return rules;
                    }({
                        overflowMode
                    })
                }
            ],
            [
                (0, _text.TextContext),
                {}
            ],
            [
                (0, _icon.IconContext),
                {
                    render: (0, _centerBaseline.centerBaseline)({
                        slot: 'icon',
                        styles: " _Ja13"
                    }),
                    styles: " ZuUmpre13 FuUmpre13 I67logd13 _va13"
                }
            ]
        ],
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                ...(0, _filterDOMProps.filterDOMProps)(otherProps),
                role: "presentation",
                className: (props1.UNSAFE_className || '') + badge({
                    variant,
                    size,
                    fillStyle
                }, props1.styles),
                style: props1.UNSAFE_style,
                ref: domRef,
                children: typeof children === 'string' || isTextOnly ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                    children: children
                }) : children
            })
        })
    });
});

},{"0":"4Zx2m","1":"edtSF","2":"jeZxC","3":"i2kW3","react/jsx-runtime":"2Is6Z","./CenterBaseline":"1vpL9","react-aria-components/slots":"bA6Cz","react-aria/filterDOMProps":"c0Owd","./Icon":"jQAJE","react-aria-components/Text":"jt9fm","react":"a1TxN","./Skeleton":"1mUnF","./Content":"10r6w","./useDOMRef":"9tqah","./useSpectrumContextProps":"8SU0q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4Zx2m":[function() {},{}],"edtSF":[function() {},{}],"jeZxC":[function() {},{}],"i2kW3":[function() {},{}],"hYP4Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TAB_DEFS", ()=>TAB_DEFS);
var _jsxRuntime = require("react/jsx-runtime");
var _adobeLogo = require("./icons/AdobeLogo");
var _reactAriaLogo = require("./icons/ReactAriaLogo");
const TAB_DEFS = {
    'react-spectrum': {
        label: 'React Spectrum',
        description: "Components for Adobe's Spectrum design system",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adobeLogo.AdobeLogo), {})
    },
    'react-aria': {
        label: 'React Aria',
        description: 'Style-free components and hooks for building accessible UIs',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaLogo.ReactAriaLogo), {})
    }
};

},{"react/jsx-runtime":"2Is6Z","./icons/AdobeLogo":"5Bj5G","./icons/ReactAriaLogo":"iQPne","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=Divider.57ef1504.js.map
